import React from 'react'

interface ToastProps {
  show: boolean
  message: string
}

const Toast: React.FC<ToastProps> = ({ show, message }) => {
  return (
    <div id="toast" className={`toast ${!show ? 'hidden' : ''}`}>
      {message}
    </div>
  )
}

export default Toast 